import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { BasketPopover } from '../components/basket/basket-popover/BasketPopover';
import { makeGetBasketMappedProductsState, makeGetBasketVouchersState, makeGetBasketDeliveryInfoState, makeGetBasketPricingState, makeGetBasketStatusState, } from '../redux/basket/selectors/BasketSelector';
export const BasketPopoverContainer = ({ hrefViewCart, freeDeliveryMessage, }) => {
    const products = useSelector(makeGetBasketMappedProductsState());
    const pricing = useSelector(makeGetBasketPricingState());
    const deliveryInfo = useSelector(makeGetBasketDeliveryInfoState());
    const status = useSelector(makeGetBasketStatusState());
    const vouchers = useSelector(makeGetBasketVouchersState());
    return (_jsx("div", { "data-analytics-bannerid": "header-shopping-cart", children: _jsx(BasketPopover, { products: products, vouchers: vouchers, pricing: pricing, status: status, hrefViewCart: hrefViewCart, deliveryInfo: deliveryInfo, freeDeliveryMessage: freeDeliveryMessage }) }));
};
